module.exports = __webpack_public_path__ + "img/cat_sedang.0ad82b47.png";